var map = {
	"./DEV.config.js": 570,
	"./LIVE.config.js": 571,
	"./PROD.config.js": 572,
	"./QA.config.js": 573,
	"./SIT.config.js": 574
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 667;


//////////////////
// WEBPACK FOOTER
// ./src/config ^\.\/.*\.config\.js$
// module id = 667
// module chunks = 0